module.exports = __webpack_public_path__ + "assets/img/7.5cc0803c.png";